import React from 'react';
import { Chip } from '@mui/material';
import { ColumnConfig } from '../Shared/Components/DataTable';
import { PartySearchItem, normalizePartyType } from './Types/partyTypes';

const getPartyTypeLabel = (partyType: PartySearchItem['partyType']): string =>
  normalizePartyType(partyType) === 'organization' ? 'Organizacja' : 'Osoba fizyczna';

export const partyColumns: ColumnConfig<PartySearchItem>[] = [
  { key: 'id', label: 'ID' },
  { key: 'displayName', label: 'Nazwa / osoba' },
  {
    key: 'partyType',
    label: 'Typ strony',
    render: (row) => getPartyTypeLabel(row.partyType),
  },
  { key: 'taxId', label: 'NIP' },
  { key: 'email', label: 'E-mail' },
  { key: 'phone', label: 'Telefon' },
  { key: 'city', label: 'Miasto' },
  {
    key: 'isActive',
    label: 'Status',
    render: (row) => (
      <Chip
        label={row.isActive ? 'Aktywna' : 'Nieaktywna'}
        color={row.isActive ? 'success' : 'default'}
        size="small"
      />
    ),
  },
];

